import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import BankIncrease from "./BankIncrease";
import styles from "./IncreaseBalance.module.scss";
import OnlineIncrease from "./OnlineIncrease";
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";
import { useDispatch, useSelector } from "react-redux";
import { userCoinBalance } from "../../../../actions/user";
import { showPrice } from "../../../../utils/priceFunc";
import { getUsersCards } from "../../../../services/userServices";
export default function IncreaseBalance() {
  const [swapButton, setSwapButton] = useState("online-payment");
  const UserIRT = useSelector((state) => state.fullUserInfo.coinBalance);
  const [cards, setCards] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(userCoinBalance("irt"));
    const getUserCards = async () => {
      const data = await getUsersCards();
      setCards(data.data.cards);
    };
    getUserCards();
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.back_btn}>
        <img
          src={ArrowBackIcon}
          alt="BACK"
          width={15}
          height={15}
          onClick={() => history.goBack()}
          className="convertPicToWhite"
        />
      </div>
      <div className={`font_color_white ${styles.title_of_page}`}>
        افزایش اعتبار
      </div>
      <div className={styles.button_for_swap}>
        <div
          className={` font_color_white ${styles.button_swap} ${
            swapButton === "bank-payment"
              ? `font_color_change_to_green ${styles.button_swap_active}`
              : ""
          }`}
          onClick={() => setSwapButton("bank-payment")}
        >
          واریز بانکی
        </div>
        <div
          className={`font_color_white ${styles.button_swap} ${
            swapButton === "online-payment"
              ? `font_color_change_to_green ${styles.button_swap_active}`
              : ""
          }`}
          onClick={() => setSwapButton("online-payment")}
        >
          پرداخت آنلاین
        </div>
      </div>
      <div className={styles.container_user_balance}>
        <div className={styles.head_of_table_titles}>
          <div className={`font_color_white ${styles.head_title}`}>
            قابل برداشت
          </div>
          <div className={`font_color_white ${styles.head_title}`}>قفل شده</div>
          <div className={`font_color_white ${styles.head_title}`}>
            موجودی کل
          </div>
        </div>
        <div className={`font_color_white ${styles.user_moneys}`}>
          <div className={styles.all_balance}>
            <div className={styles.forMoneysGrid}>
              <div>تومان</div>
              <div>
                {UserIRT?.asset?.balance &&
                  showPrice(UserIRT?.asset?.balance - UserIRT?.asset?.locked)}
              </div>
            </div>
          </div>
          <div className={styles.lock_balance}>
            <div className={styles.forMoneysGrid}>
              <div>تومان</div>
              <div>{showPrice(UserIRT?.asset?.locked)}</div>
            </div>
          </div>
          <div className={styles.removable_balance}>
            <div className={styles.forMoneysGrid}>
              <div>تومان</div>
              <div>{showPrice(UserIRT?.asset?.balance)}</div>
            </div>
          </div>
        </div>
      </div>
      <main>
        {swapButton === "online-payment" ? (
          <OnlineIncrease cards={cards} />
        ) : swapButton === "bank-payment" ? (
          <BankIncrease />
        ) : (
          "No Content To Show - Reload Page Or Contact Support"
        )}
      </main>
    </div>
  );
}
